export const INTRO_TUTORIAL_SCREEN_TOP_TEXT = 'Click to wake Suki.'
export const INTRO_TUTORIAL_SCREEN_BOTTOM_TEXT = 'Suki only listens when awake.'
export const INTRO_TUTORIAL_VIDEO_TITLE_GREETING = 'Hello.   I\'m Suki.'
export const INTRO_TUTORIAL_VIDEO_DESC = 'Let me show you how I can help create notes.'
export const INTRO_TUTORIAL_TIP_SCREEN_TITLE = 'Here are some things you can ask me to do.'
export const INTRO_TUTORIAL_TIP_1 = '“Suki ...'
export const INTRO_TUTORIAL_TIP_2 = 'Go to my schedule'
export const INTRO_TUTORIAL_TIP_3 = 'Go back'
export const INTRO_TUTORIAL_TIP_4 = 'Start a follow up note for John Smith'
export const INTRO_TUTORIAL_TIP_5 = 'Bring up my unfinished notes'
export const INTRO_TUTORIAL_TIP_6 = 'Show notes for Mary Roberts”'
export const SKIP = 'Skip'
export const CLOSE_VIDEO = 'Close'
export const SCREEN_1 = 'Screen_1'
export const SCREEN_2 = 'Screen_2'
export const SCREEN_3 = 'Screen_3'
export const SCREEN_4 = 'Screen_4'
export const DEFAULT = 'Default'
export const ALT_TEXT = 'Downward Arrow'
export const MORE_TIPS = 'More Tips'
export const MORE_TIP_1 = 'Remember to say “Suki” when you want me to do something.'
export const MORE_TIP_2 = 'Talk at a natural pace, as you would talk to a person.'
export const ADDITIONAL_HELP = 'For more information choose Help in the menu.'
export const VIDEO_FILES = {
  OOBE: 'web-oobe-non-emr.mp4',
  OOBE_ATHENA: 'web-oobe-athena.mp4',
  OOBE_EPIC_CERNER: 'web-oobe-epic-cerner.mp4'
}
